/**
 * CallsContainer is an AltContainer for <Calls/>. It gets its props from
 * SearchStore.getState().get('searchTerm') so that it knows whether
 * a user is "in" a search or not
 */

import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';

import AuthStore from 'stores/AuthStore';
import CallStore from 'stores/files/CallStore';
import CoachingPlaylistStore, {
  PLAYLIST_MODE_TYPE,
  PLAYLIST_VISIBILITY,
} from 'stores/CoachingPlaylistStore';
import SearchStore from 'stores/SearchStore';

import SearchSidebar from './SearchSidebar';
import SidebarStore from 'stores/SidebarStore';

class SearchSidebarContainer extends React.Component {
  static getStores() {
    return [SearchStore, AuthStore, CallStore, CoachingPlaylistStore, SidebarStore];
  }

  static getPropsFromStores(props) {
    const searchState = SearchStore.getState();

    const loggedUser = AuthStore.getState().user;
    const userPermissions = loggedUser ? loggedUser.permissions : null;

    const hasDrilldownApplied = !!CallStore.getState().drilldownCalls;
    const playlistStore = CoachingPlaylistStore.getState();
    const addingCallsToPlaylist =
      playlistStore.visibility !== PLAYLIST_VISIBILITY.hidden &&
      playlistStore.mode === PLAYLIST_MODE_TYPE.ADD_CALLS;

    const widgetWhitelistKey = addingCallsToPlaylist && 'addCallsByCallsTab';

    return {
      widgetWhitelistKey,
      isAdvancedSearch: searchState.get('isAdvancedSearch'),
      searchTerm: searchState.get('searchTerm'),
      hideSidebar: hasDrilldownApplied || !SidebarStore.getState().get('open'),
      userPermissions: userPermissions,
    };
  }

  render() {
    return (
      <AltContainer>
        <SearchSidebar {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(SearchSidebarContainer);
